import * as React from 'react';
import { useEffect } from 'react';
import Button from '@mui/joy/Button';
import Divider from '@mui/joy/Divider';
import DialogTitle from '@mui/joy/DialogTitle';
import DialogContent from '@mui/joy/DialogContent';
import DialogActions from '@mui/joy/DialogActions';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import Typography from "@mui/joy/Typography";
import ApiService from "../../axios/Bookings-Axios";

interface ConfirmSendKlarnaInvoiceProps {
    openState: boolean;
    parentCallback: (success: boolean) => void;
    booking_id: number;
}

export default function ConfirmSendKlarnaInvoice({ openState, parentCallback, booking_id }: ConfirmSendKlarnaInvoiceProps) {
    const [open, setOpen] = React.useState<boolean>(openState);

    useEffect(() => {
        setOpen(openState);
    }, [openState]);

    async function actionSend() {
        try {
            await ApiService.sendKlarnaInvoice(booking_id);
            setOpen(false);
            parentCallback(true);
        } catch (error) {
            console.error("Failed to send Klarna invoice:", error);
            setOpen(false);
            parentCallback(false);
        }
    }

    function actionCancel() {
        setOpen(false);
        parentCallback(false);
    }

    return (
        <React.Fragment>
            <Modal open={open} onClose={() => setOpen(false)}>
                <ModalDialog variant="outlined" role="alertdialog" sx={{
                    width: { xs: '90vw', sm: 'auto' },
                    maxWidth: { xs: '90vw', sm: '450px' },
                }}>
                    <DialogTitle>
                        <WarningRoundedIcon />
                        Are you sure you want to send the Klarna Invoice?
                    </DialogTitle>
                    <Divider />
                    <DialogContent>
                        <Typography>This will also send an instructions email on how to pay the invoice with Klarna</Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="solid" color="success" onClick={actionSend}>
                            Send Invoice
                        </Button>
                        <Button variant="plain" color="neutral" onClick={actionCancel}>
                            Cancel
                        </Button>
                    </DialogActions>
                </ModalDialog>
            </Modal>
        </React.Fragment>
    );
}